
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import LocalBusinessSchema from "../components/LocalBusinessSchema";
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Seaterbusonrentinpune() {



    const cardData =
    {
        keyword: '32 Seater Bus On Rent in Pune',
        heading: 'Amruta Travels: 32 Seater Bus On Rent in Pune',
        headingDescription: (
  <>
    Amruta Travels offers{" "}
    <Link to="/bus-on-rent-in-pune">
      32 Seater Bus On Rent in Pune
    </Link>
    , providing a reliable, comfortable, and hassle-free transportation solution
    for medium-sized groups. Whether it is for weddings, corporate events,
    school trips, family outings, or outstation travel, our well-maintained
    32-seater buses ensure a smooth and enjoyable ride. With punctual service,
    experienced drivers, affordable pricing, and 24/7 availability, we make
    group travel simple and stress-free. Book your 32 Seater Bus with Amruta
    Travels and travel together in comfort and style!
  </>
),


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

          "services": [
    {
      "name": "32 Seater Bus Rent in Pune",
      "description": "Amruta Travels offers 32-seater bus rentals in Pune for a wide range of travel needs, including corporate, family, school, and religious trips. Our buses are clean, safe, and equipped with experienced drivers to ensure a smooth journey across the city or outstation."
    },
    {
      "name": "32 Seater Bus on Rent in Pune",
      "description": "Looking for a reliable 32-seater bus on rent in Pune? Amruta Travels provides affordable and punctual service for all group travel requirements. Whether it’s a wedding, corporate event, or pilgrimage, our fleet is ready to serve with maximum comfort."
    },
    {
      "name": "32 Seater Bus Price in Pune",
      "description": "Get competitive pricing for 32-seater bus rental services in Pune with Amruta Travels. We offer transparent, per km or package-based pricing for weddings, corporate travel, outstation trips, and more. Contact us for a custom quote."
    },
    {
      "name": "32 Seater Bus On Hire",
      "description": "Hire a 32-seater bus from Amruta Travels for group transportation in Pune. Suitable for schools, offices, families, and travel agencies, our buses offer ample seating, legroom, and comfort for long or short journeys."
    },
    {
      "name": "32 Seater Bus on Hire for Wedding in Pune",
      "description": "Make wedding logistics simple by hiring a 32-seater bus with Amruta Travels. Our wedding transportation services in Pune ensure guests travel comfortably and on time between ceremonies and reception venues."
    },
    {
      "name": "32 Seater Bus on Rent for Marriage",
      "description": "Planning a marriage function? Amruta Travels offers 32-seater bus rentals that are ideal for ferrying guests between hotels, venues, and homes. Our drivers are trained to handle wedding-day schedules and guest needs efficiently."
    },
    {
      "name": "32 Seater Bus on Rent Corporate Events",
      "description": "Need transportation for a corporate outing or seminar? Amruta Travels provides 32-seater buses on rent for corporate events in Pune, with features like AC, clean interiors, and professional chauffeurs for a seamless business travel experience."
    },
    {
      "name": "32 Seater Bus on Rent for Mahabaleshwar",
      "description": "Plan a scenic escape from Pune to Mahabaleshwar with Amruta Travels’ 32-seater bus rental. Enjoy the hills with your group in a safe, comfortable, and affordable vehicle equipped for long-distance travel."
    },
    {
      "name": "32 Seater AC Bus on Hire",
      "description": "Beat the heat with our 32-seater AC buses on hire. Amruta Travels ensures passenger comfort on all types of journeys, whether you're traveling locally in Pune or heading to a weekend getaway or wedding."
    },
    {
      "name": "32 Seater Non-AC Bus on Hire",
      "description": "Looking for a budget travel option? Our 32-seater non-AC buses are perfect for school trips, small wedding groups, and community outings. Enjoy cost savings without compromising on safety and reliability."
    },
    {
      "name": "32 Seater Bus Hire for Ashtavinayak Darshan",
      "description": "Book your Ashtavinayak Darshan Yatra with Amruta Travels in a comfortable 32-seater bus. We offer a smooth and spiritually uplifting travel experience with reliable drivers and flexible tour schedules."
    },
    {
      "name": "32 Seater Bus Hire for 5 Jyotirlinga Darshan",
      "description": "Experience the spiritual journey to Maharashtra’s sacred Jyotirlingas with Amruta Travels' 32-seater buses. Ideal for group pilgrimages, our service ensures clean vehicles, on-time departures, and devotional comfort throughout the trip."
    },
    {
      "name": "Pune to Konkan Darshan 32 Seater Bus on Rent",
      "description": "Travel the beautiful Konkan coastline with your group in our 32-seater bus. Amruta Travels offers outstation rental services from Pune to Konkan, perfect for family vacations, festivals, or heritage tours."
    },
    {
  "name": "32 Seater Bus on Rent in Hadapsar",
  "description": (
    <>
      Located in Hadapsar? Book our{" "}
      <Link to="/bus-on-rent-in-pune">
        32 Seater Bus On Rent in Pune
      </Link>{" "}
      for local and outstation travel. We provide clean buses, professional
      drivers and door-to-door pickup for comfortable group travel.
    </>
  )
},
    {
  "name": "32 Seater Bus on Rent in Pimpri Chinchwad",
  "description": (
    <>
      Looking for group transportation in Pimpri Chinchwad? Hire our{" "}
      <Link to="/bus-on-rent-in-pune">
        Bus On Rent in Pune
      </Link>{" "}
      service for corporate events, weddings, school trips and outstation
      travel.
    </>
  )
},
    {
  "name": "Pune to Bhimashankar 32 Seater Bus Hire",
  "description": (
    <>
      Planning a Bhimashankar trip? Hire our{" "}
      <Link to="/bus-on-rent-in-pune">
        32 Seater Bus On Rent in Pune
      </Link>{" "}
      for comfortable group travel with experienced drivers.
    </>
  )
},
    {
      "name": "Pune to Ashtavinayak 32 Seater Bus on Rent",
      "description": "Book a 32-seater bus from Pune for the complete Ashtavinayak Yatra. Amruta Travels offers experienced drivers, route planning, and clean buses for a divine travel experience with your group or temple community."
    },
    {
      "name": "32 Seater Bus on Rent in Kothrud",
      "description": "For residents or businesses in Kothrud, Amruta Travels offers 32-seater bus rental services for weddings, school outings, corporate events, and more. We ensure timely pickups and personalized support throughout your booking."
    },
    {
"name":"32 Seater Bus for Corporate Office",
"description":(
<>
Need employee transportation? Our{" "}
<Link to="/bus-on-rent-in-pune">
Corporate Bus Hire in Pune
</Link>{" "}
service offers punctual daily staff transportation with clean AC buses.
</>
)
},
    {
"name":"32 Seater Bus for Outstation from Pune",
"description":(
<>
Planning an outstation trip? Book our{" "}
<Link to="/bus-on-rent-in-pune">
Bus On Rent in Pune
</Link>{" "}
service for comfortable travel to Mahabaleshwar, Shirdi, Goa, Nashik and more.
</>
)
},
    {
      "name": "32 Seater Bus Rental Services in Pune",
      "description": "Get complete 32-seater bus rental services from Amruta Travels in Pune. We cater to weddings, religious tours, school trips, and corporate travel with a reliable fleet, affordable prices, and trusted service."
    }
  ],

  "tableData": [
    ["32 Seater Bus Rent in Pune", "32 Seater Bus on Rent in Pune"],
    ["32 Seater Bus Price in Pune", "32 Seater Bus On Hire"],
    ["32 Seater Bus on Hire for Wedding in Pune", "32 Seater Bus on Rent for Marriage"],
    ["32 Seater Bus on Rent Corporate Events", "32 Seater Bus on Rent for Mahabaleshwar"],
    ["32 Seater AC Bus on Hire", "32 Seater Non-AC Bus on Hire"],
    ["32 Seater Bus Hire for Ashtavinayak Darshan", "32 Seater Bus Hire for 5 Jyotirlinga Darshan"],
    ["Pune to Konkan Darshan 32 Seater Bus on Rent", "32 Seater Bus on Rent in Hadapsar"],
    ["32 Seater Bus on Rent in Pimpri Chinchwad", "Pune to Bhimashankar 32 Seater Bus Hire"],
    ["Pune to Ashtavinayak 32 Seater Bus on Rent", "32 Seater Bus on Rent in Kothrud"],
    ["32 Seater Bus for Corporate Office", "32 Seater Bus for Outstation from Pune"],
    [
"32 Seater Bus Rental Services in Pune",
"32 Seater Tourist Bus Hire Pune"
]
  ],





   "whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Group Travel",
    "WhyChoosedescription": "Amruta Travels offers 32 Seater Bus Rent in Pune, perfect for large group travel. With spacious seating, ample legroom, and air conditioning, our buses ensure a relaxed and enjoyable ride for all passengers."
  },
  {
    "WhyChooseheading": "Ideal for Events, Tours, and Outings",
    "WhyChoosedescription": "Our 32-seater buses are ideal for weddings, corporate events, school trips, and sightseeing tours. No matter the occasion, we provide reliable and comfortable transportation tailored to your group’s needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Safety and professionalism come first. Our trained drivers are courteous, punctual, and knowledgeable about routes in and around Pune, ensuring a safe and hassle-free journey for your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and budget-friendly pricing for 32 Seater Bus Rent in Pune. With clear, upfront rates and no hidden charges, you can plan your group travel expenses with confidence."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly cleaned and serviced to ensure maximum comfort and hygiene. We maintain high standards for vehicle upkeep to give you a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "24/7 Availability and Flexible Scheduling",
    "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, our 32 Seater Bus Rent in Pune is available 24/7 to match your schedule. We offer flexible booking options to meet your specific needs."
  },
  {
    "WhyChooseheading": "Customized Travel Itineraries",
    "WhyChoosedescription": "We offer fully customizable routes and schedules based on your group’s requirements. Whether it’s multiple pick-up points or planned stopovers, we’ll tailor the travel plan to suit your itinerary."
  },
  {
    "WhyChooseheading": "Easy Booking with Excellent Support",
    "WhyChoosedescription": "Booking a 32 Seater Bus with Amruta Travels is quick and hassle-free. Use our online platform, call our customer support, or visit our office—we provide smooth and convenient booking with full assistance."
  }
]






















    }

const faqData = [
  {
    question: 'How can I rent a 32 seater bus in Pune with Amruta Travels?',
    answer: 'Renting a 32 seater bus in Pune with Amruta Travels is simple. You can book through our website, call our support team, or visit our office. We’ll guide you through the process and tailor the booking to your travel needs.',
  },
  {
    question: 'What are the features of the 32 seater bus?',
    answer: 'Our 32 seater buses come with comfortable push-back seats, air conditioning, spacious interiors, and ample luggage storage. They are ideal for group tours, corporate events, school outings, and wedding transportation.',
  },
  {
    question: 'Is the 32 seater bus available for outstation trips?',
    answer: 'Yes, the 32 seater bus is perfect for outstation travel from Pune. Whether it’s a day trip or multi-day journey, we ensure a smooth and comfortable ride with experienced drivers.',
  },
  {
    question: 'Can I book the bus for local travel within Pune?',
    answer: 'Absolutely! Our 32 seater buses are available for local use within Pune, including events, city tours, corporate transport, and shuttle services.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are regularly maintained and thoroughly sanitized before every trip to ensure passenger safety, cleanliness, and comfort.',
  },
  {
    question: 'How much does it cost to rent a 32 seater bus in Pune?',
    answer: 'The cost depends on the travel distance, trip duration, and additional services. Contact us with your trip details for a transparent and customized quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop points. Just share your schedule in advance and we’ll plan the route accordingly.',
  },
  {
    question: 'Do you provide drivers with the 32 seater bus?',
    answer: 'Yes, all rentals include experienced and licensed drivers who ensure punctuality, safety, and a smooth travel experience throughout the journey.',
  },
  {
    question: 'Is the 32 seater bus suitable for weddings and events?',
    answer: 'Definitely! Our 32 seater bus is a popular choice for wedding guest transportation, group functions, and other special events in and around Pune.',
  },
  {
    question: 'Why choose Amruta Travels for 32 seater bus rental in Pune?',
    answer: 'Amruta Travels is known for reliable, professional service with well-maintained buses, trained drivers, and hassle-free booking. We prioritize comfort, punctuality, and customer satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kiran Pawar',
    role: 'Corporate Travel Manager, Pune',
    text: 'We hired a 32 seater bus from Amruta Travels for a company event. The bus was clean, on time, and the driver was very courteous. Excellent service overall!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Swati Joshi',
    role: 'Wedding Coordinator, Pune',
    text: 'Amruta Travels helped us transport wedding guests with their 32 seater bus. Everything was smooth and professional. Our guests were very comfortable and happy.',
    rating: 5,
  },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [

{
    src: "/images/gallery/24.jpg",
    alt: "32 Seater AC Bus Hire in Pune"
},

{
    src: "/images/gallery/28.jpg",
    alt: "Luxury 32 Seater Bus Rental Pune"
},

{
    src: "/images/gallery/2.jpg",
    alt: "Corporate Bus Rental Pune"
},

{
    src: "/images/gallery/3.jpg",
    alt: "Wedding Bus Hire Pune"
},

{
    src: "/images/gallery/24.jpg",
    alt: "32 Seater Tourist Bus Pune"
},

{
    src: "/images/gallery/27.jpg",
    alt: "Outstation Bus Rental Pune"
},

{
    src: "/images/gallery/29.jpg",
    alt: "Employee Transport Bus Pune"
},

{
    src: "/images/gallery/30.jpg",
    alt: "School Trip Bus Rental Pune"
},

{
    src: "/images/gallery/31.jpg",
    alt: "Amruta Travels 32 Seater Bus Fleet Pune"
}

];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",

  "serviceType": "32 Seater Bus On Rent in Pune",

  "name": "32 Seater Bus On Rent in Pune",

  "provider": {
    "@type": "TravelAgency",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },

  "image": "https://bushireinpune.com/images/keyword/4.jpg",

  "description":
    "Book a 32 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate travel, school trips, family tours, airport transfers and outstation travel.",

  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },

  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/32-seater-bus-on-rent-in-pune"
  }
};

const faqSchema = {
  "@context":"https://schema.org",
  "@type":"FAQPage",
  "mainEntity":faqData.map((faq)=>({
      "@type":"Question",
      "name":faq.question,
      "acceptedAnswer":{
          "@type":"Answer",
          "text":faq.answer
      }
  }))
}

const breadcrumbSchema = {
  "@context":"https://schema.org",
  "@type":"BreadcrumbList",
  "itemListElement":[
    {
      "@type":"ListItem",
      "position":1,
      "name":"Home",
      "item":"https://bushireinpune.com/"
    },
    {
      "@type":"ListItem",
      "position":2,
      "name":"Bus on Rent in Pune",
      "item":"https://bushireinpune.com/bus-on-rent-in-pune"
    },
    {
      "@type":"ListItem",
      "position":3,
      "name":"32 Seater Bus On Rent in Pune",
      "item":"https://bushireinpune.com/32-seater-bus-on-rent-in-pune"
    }
  ]
}






    return (
        <div>


<SEO
title="32 Seater Bus On Rent in Pune | AC Bus Hire | Amruta Travels"
description="Book a 32 Seater Bus On Rent in Pune with Amruta Travels. Perfect for weddings, corporate travel, employee transport, family tours and outstation trips."
canonical="https://bushireinpune.com/32-seater-bus-on-rent-in-pune"
image="https://bushireinpune.com/images/keyword/4.jpg"
schema={[
productSchema,
faqSchema,
breadcrumbSchema
]}
/>

<LocalBusinessSchema />

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
32 Seater Bus On Rent in Pune
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="bus-rental" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/4.jpg"
    alt="32 Seater Bus On Rent in Pune by Amruta Travels"
    loading="eager"
    fetchPriority="high"
    width="900"
    height="500"
/>
                            <h2
    className="py-1"
    style={{
        color: '#322E77',
        textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)',
        fontWeight: 'bold'
    }}
>
    {cardData.heading}
</h2><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
<BusRatesTable />

<div className="my-4">
    <p>
        Looking for a different bus size for your group? Amruta Travels
        also provides{" "}
        <Link to="/22-seater-bus-on-rent-in-pune">
            22 Seater Bus On Rent in Pune
        </Link>
        ,{" "}
        <Link to="/24-seater-bus-on-rent-in-pune">
            24 Seater Bus On Rent in Pune
        </Link>
        ,{" "}
        <Link to="/35-seater-bus-on-rent-in-pune">
            35 Seater Bus On Rent in Pune
        </Link>
        {" "}and{" "}
        <Link to="/40-seater-bus-on-rent-in-pune">
            40 Seater Bus On Rent in Pune
        </Link>
        {" "}for different group sizes and travel requirements.
    </p>
</div>
<div className="my-5">
    <h2>32 Seater Bus Specifications</h2>
    <div className="alert alert-primary mt-4">

<h3>Need a 32 Seater Bus in Pune?</h3>

<p>
Call Amruta Travels today for the best price on 32 Seater Bus On Rent in Pune.
Our buses are available for weddings, corporate travel, school trips, religious tours and outstation travel.
</p>

<a href="tel:+917353109555" className="btn btn-primary">
Call Now
</a>

</div>

    <table className="table table-bordered">
        <tbody>

            <tr>
                <th>Seating Capacity</th>
                <td>32 Passengers</td>
            </tr>

            <tr>
                <th>Air Conditioning</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Pushback Seats</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Music System</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Charging Points</th>
                <td>Available</td>
            </tr>

            <tr>
                <th>Luggage Space</th>
                <td>Large</td>
            </tr>

            <tr>
                <th>Driver Included</th>
                <td>Yes</td>
            </tr>

            <tr>
                <th>Suitable For</th>
                <td>
Corporate Travel,
Wedding,
School Trips,
Family Tours,
Outstation Travel
</td>
            </tr>

        </tbody>
    </table>
</div>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>

<div className="my-5">

<h2>Related Bus Rental Services</h2>

<ul>

<li>
<Link to="/22-seater-bus-on-rent-in-pune">
22 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/24-seater-bus-on-rent-in-pune">
24 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/25-seater-bus-on-rent-in-pune">
25 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/35-seater-bus-on-rent-in-pune">
35 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/40-seater-bus-on-rent-in-pune">
40 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/45-seater-bus-on-rent-in-pune">
45 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/49-seater-bus-on-rent-in-pune">
49 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/50-seater-bus-on-rent-in-pune">
50 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/53-seater-bus-on-rent-in-pune">
53 Seater Bus On Rent in Pune
</Link>
</li>

</ul>

</div>
                            <div className="my-5">

<h2>People Also Search For</h2>

<ul>

<li>
<Link to="/25-seater-bus-on-rent-in-pune">
25 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/35-seater-bus-on-rent-in-pune">
35 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/40-seater-bus-on-rent-in-pune">
40 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/45-seater-bus-on-rent-in-pune">
45 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/49-seater-bus-on-rent-in-pune">
49 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/50-seater-bus-on-rent-in-pune">
50 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/53-seater-bus-on-rent-in-pune">
53 Seater Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/bus-on-rent-in-pune">
Bus On Rent in Pune
</Link>
</li>

<li>
<Link to="/tempo-traveller-hire-in-pune">
Tempo Traveller Hire in Pune
</Link>
</li>

</ul>

</div>

<div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => {
    return (
        <div className="box1" key={index}>
            <Link
                to="/bus-on-rent-in-pune"
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img
    src={e.place}
    alt={`${e.text} | Amruta Travels`}
    loading="lazy"
    width="120"
    height="90"
/>
                </div>

                <div className="b2">
                    <span className="px-3">
                        {e.text}
                    </span>
                </div>

            </Link>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
src={image.src}
alt={image.alt}
className="gallery-image"
loading="lazy"
decoding="async"
width="300"
height="200"
/>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Seaterbusonrentinpune;